export const MINUTES_INTERVAL_VALUES = [1, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55] as const;
export type SyncWorkerMinutesInterval = (typeof MINUTES_INTERVAL_VALUES)[number];

export type SyncWorkerInterval =
  | { kind: 'minutes'; value: SyncWorkerMinutesInterval }
  | { kind: 'hours'; value: number }
  | { kind: 'days'; value: 1; hour?: number };

export function parseCronInterval(value: string): SyncWorkerInterval | null {
  const trimmed = value.trim();
  if (trimmed === '* * * * *') {
    return { kind: 'minutes', value: 1 };
  }

  const minuteMatch = trimmed.match(/^\*\/(\d+)\s+\*\s+\*\s+\*\s+\*$/);
  if (minuteMatch) {
    const minutes = Number(minuteMatch[1]);
    if (MINUTES_INTERVAL_VALUES.includes(minutes as SyncWorkerMinutesInterval)) {
      return { kind: 'minutes', value: minutes as SyncWorkerMinutesInterval };
    }
    return null;
  }

  const hourMatch = trimmed.match(/^0\s+\*\/(\d+)\s+\*\s+\*\s+\*$/);
  if (hourMatch) {
    const hours = Number(hourMatch[1]);
    if (Number.isInteger(hours) && hours >= 1 && hours <= 23) {
      return { kind: 'hours', value: hours };
    }
    return null;
  }

  if (trimmed === '0 * * * *') {
    return { kind: 'hours', value: 1 };
  }

  const dayMatch = trimmed.match(/^0\s+(\d+)\s+\*\s+\*\s+\*$/);
  if (dayMatch) {
    const hour = Number(dayMatch[1]);
    if (Number.isInteger(hour) && hour >= 0 && hour <= 23) {
      return { kind: 'days', value: 1, hour };
    }
    return null;
  }

  return null;
}

export function buildCronFromInterval(interval: SyncWorkerInterval): string {
  if (interval.kind === 'minutes') {
    if (interval.value === 1) {
      return '* * * * *';
    }
    return `*/${String(interval.value)} * * * *`;
  }
  if (interval.kind === 'hours') {
    return `0 */${String(interval.value)} * * *`;
  }
  const hour = typeof interval.hour === 'number' ? interval.hour : 0;
  return `0 ${String(hour)} * * *`;
}
